var map = {
	"./00006_wide.png": 2017,
	"./00007_wide.png": 4386,
	"./1091500_wide.png": 918,
	"./79709895_wide.png": 8611,
	"./flappy_chicken_reflec_wide.png": 5423,
	"./parking_at_bonn_reflec_wide.png": 4453,
	"./tux_racer_reflec_wide.png": 6205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;